import * as Msdyn365 from '@msdyn365-commerce/core';
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent, onTelemetryClick } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    disabled: boolean;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IRoofTableLinks {
    links: ILinksData[] | undefined;
    //requestContext: Msdyn365.IRequestContext;
    telemetryContent: ITelemetryContent;
    role?: string;
    //onTextChange?(index: number): (event: Msdyn365.ContentEditableEvent) => void;
}

export class RoofTableLinks extends React.PureComponent<IRoofTableLinks> {
    public render(): JSX.Element {
        const editableLinks = this._mapEditableLinks(this.props.links);
        const disabledLinks = this._mapDisabledLinks(this.props.links);

        return (
            <div className='ms-content-block__cta'>
                {editableLinks && editableLinks.length > 0 ? (
                    <Msdyn365.Links
                        links={editableLinks}
                        /*editProps={{ onTextChange: this.props.onTextChange, requestContext: this.props.requestContext }}*/
                    />
                ) : null}
                {disabledLinks && disabledLinks.length > 0 ? disabledLinks : null}
            </div>
        );
    }

    private readonly _mapEditableLinks = (linkdata: ILinksData[] | undefined): Msdyn365.ILinksData[] | null => {
        if (!linkdata || linkdata.length === 0) {
            return null;
        }
        const editableLinks: Msdyn365.ILinksData[] = [];

        linkdata.forEach((link, index) => {
            // Construct telemetry attribute to render
            const payLoad = getPayloadObject('click', this.props.telemetryContent, '', '');
            const linkText = link.linkText ? link.linkText : '';
            payLoad.contentAction.etext = linkText;
            const attributes = getTelemetryAttributes(this.props.telemetryContent, payLoad);
            const btnClass = index === 0 ? 'msc-cta__primary' : 'msc-cta__secondary';

            if (!link.disabled) {
                const editableLink: Msdyn365.ILinksData = {
                    ariaLabel: link.ariaLabel,
                    className: btnClass,
                    linkText: link.linkText,
                    linkUrl: link.linkUrl.destinationUrl,
                    openInNewTab: link.openInNewTab,
                    role: this.props.role,
                    additionalProperties: attributes,
                    onClick: onTelemetryClick(this.props.telemetryContent, payLoad, linkText)
                };
                editableLinks.push(editableLink);
            }
        });

        return editableLinks;
    };

    private readonly _mapDisabledLinks = (linkdata: ILinksData[] | undefined): JSX.Element[] | null => {
        if (!linkdata || linkdata.length === 0) {
            return null;
        }

        const disabledLinks = linkdata
            .filter(link => link.disabled)
            .map((link, index) => {
                return (
                    <div key={index} className='lobas-disabled-link'>
                        {link.linkText}
                    </div>
                );
            });

        return disabledLinks;
    };
}
export default RoofTableLinks;
